module.exports = __webpack_public_path__ + "static/acupun_2_lg-d67392dfa283e25143d910d23cbf3939.png";